import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from "../services/auth.service";
import { HttpCustomerService } from "../services/http/customer.service";
import { BreadcrumbService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'gea-shop-confirm-email',
    templateUrl: './confirm-email.component.html',
    styleUrls: ['./confirm-email.component.scss'],
    standalone: false
})
export class ConfirmEmailComponent implements OnInit {

  state: "validating" | "success" | "fail" | "succeeded"

  constructor(
    @Inject(HttpCustomerService) private customerService: HttpCustomerService,
    @Inject(AuthService) private authService: AuthService,
    @Inject(BreadcrumbService) private bcService: BreadcrumbService,
    private route: ActivatedRoute
  ) {
    this.state = "validating"
    this.bcService.trackPageView({label: "E-Mail Validierung", link: "confirm_email", type: "other"})
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if ("token" in params) {
        this.customerService.confirmEmail(params["token"]).subscribe(
          response => {
            if (response.status == 201) {
              this.state = "success"
            } else {
              this.state = "succeeded"
            }
            const user = this.authService.user()
            if (user) {
              this.authService.setEmailConfirmed()
            }
          },
          error => { this.state = "fail" }
        )
      }
    })
  }
}
